import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Drawer,
  useTheme
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MenuDrawerItemSideBar } from './Header';
import { useDrawer } from '../hooks/drawer/DrawerProvider';
import { GREEN_MAIN, WHITE } from '../theme/colors';

const DrawerComponent: React.FC = () => {
  const { closeDrawer, isOpen, menuItems, title } = useDrawer();
  const navigate = useNavigate();
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  const theme = useTheme();

  const GREEN_MAIN_BG = `${GREEN_MAIN}20`;
  const SUBMENU_BG = WHITE;

  const handleMenuClick = (item: MenuDrawerItemSideBar) => {
    if (item.submenu) {
      setOpenSubmenu(openSubmenu === item.nome ? null : item.nome);
    } else {
      if (item.link?.startsWith('http')) {
        window.open(item.link, '_blank');
      } else {
        navigate(item.link || '');
      }
    }
  };

  const handleSubItemClick = (link: string | undefined) => {
    if (!link) return;
    if (link.startsWith('http')) {
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
  };

  const renderMenuItems = (menu: MenuDrawerItemSideBar[]) => {
    return menu.map((item, index) => (
      <React.Fragment key={index}>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleMenuClick(item)}
            sx={{
            //   bgcolor: GREEN_MAIN_BG,
              color: GREEN_MAIN,
              '&:hover': {
                bgcolor: `${GREEN_MAIN}25`, // un po' più opaco su hover
              },
            }}
          >
            {item.icon && (
              <ListItemIcon sx={{ color: GREEN_MAIN }}>
                {item.icon}
              </ListItemIcon>
            )}
            <ListItemText
              primary={item.nome}
              primaryTypographyProps={{ fontWeight: 500 }}
            />
          </ListItemButton>
        </ListItem>

        {item.submenu && openSubmenu === item.nome && (
          <List component="div" disablePadding sx={{ bgcolor: SUBMENU_BG }}>
            {item.submenu.map((subItem, subIndex) => (
              <ListItem key={subIndex} disablePadding>
                <ListItemButton
                  onClick={() => handleSubItemClick(subItem.link)}
                  sx={{
                    pl: subItem.icon ? 2 : 4,
                    color: GREEN_MAIN,
                    '&:hover': {
                      bgcolor: `${GREEN_MAIN}10`,
                    },
                  }}
                >
                  {subItem.icon && (
                    <ListItemIcon sx={{ color: GREEN_MAIN }}>
                      {subItem.icon}
                    </ListItemIcon>
                  )}
                  <ListItemText primary={subItem.nome} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
        {index < menu.length - 1 && <Divider sx={{ borderColor: '#FFFFFF40' }} />}
      </React.Fragment>
    ));
  };

  return (
    <Drawer open={isOpen} onClose={closeDrawer}>
      <Box
        sx={{
          width: 250,
          bgcolor: GREEN_MAIN_BG,
          height: '100%',
        }}
        role="presentation"
      >
        <ListItem alignItems="center">
          <ListItemText
            primary={title}
            primaryTypographyProps={{
              fontWeight: 'bold',
              color: GREEN_MAIN,
            }}
          />
        </ListItem>
        {renderMenuItems(menuItems || [])}
      </Box>
    </Drawer>
  );
};

export default DrawerComponent;
